export function getGalleryBaseUrl(): string {
  return "https://anqr.link";
}
